<!-- 手动增改加工 -->
<template>
  <div>
    <el-dialog
      width="500px"
      :title="selfData.id ? '手动编辑加工' : '手动新增加工'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form
          ref="refForm"
          :config="formConfig"
          :column="formColumn"
          :data.sync="selfData"
          :rules="rules"
          @submit="popupConfirm"
        />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    index: {
      type: [Number, String],
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    gui_ge_shi_li: {
      type: String,
      default: ''
    },
    dan_wei: {
      type: String,
      default: ''
    },
    dan_jian_shu_liang: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          field: 'mu_ban_ming_cheng',
          title: '模板名称',
          required: true
        },
        {
          type: 'text',
          field: 'mu_ban_guan_jian_ci',
          title: '模板关键词',
          required: true,
          suffix: '英文","号分隔'
        },
        {
          type: 'text',
          field: 'gui_ge_shi_li',
          title: '规格',
          placeholder: '自动读取商品规格',
          disabled: true
        },
        {
          type: 'text',
          field: 'dan_wei',
          title: '单位',
          placeholder: '自动读取商品单位',
          disabled: true
        },
        {
          type: 'number',
          field: 'dan_jian_shu_liang',
          title: '单件数量',
          placeholder: '自动读取商品单件数量',
          disabled: true
        },
        {
          type: 'number',
          field: 'dan_jia',
          title: '单价',
          fnChange: () => {
            this.setAmount()
          }
        },
        {
          type: 'text',
          field: 'dan_jian_jin_e',
          title: '单件金额',
          placeholder: '自动计算',
          disabled: true
        }
      ],
      rules: {
        mu_ban_ming_cheng: [{ required: true, message: '请输入模板名称' }],
        mu_ban_guan_jian_ci: [{ required: true, message: '请输入模板关键词' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.initSelfData()
  },
  methods: {
    // 初始化数据
    initSelfData() {
      let result = {}
      if (this.index === '') {
        result = {
          id: '', // 工艺路线列表id
          mu_ban_ming_cheng: '', // 模板名称
          mu_ban_guan_jian_ci: '', // 模板关键词
          gui_ge_shi_li: '', // 规格
          dan_wei: '', // 单位
          dan_jian_shu_liang: '', // 单件数量
          dan_jia: '', // 单价
          dan_jian_jin_e: '' // 单件金额
        }
      } else {
        result = this.$util.deepCopy(this.list[this.index])
      }
      result.gui_ge_shi_li = this.gui_ge_shi_li
      result.dan_wei = this.dan_wei
      result.dan_jian_shu_liang = this.dan_jian_shu_liang
      this.selfData = result
    },
    // 设置单件金额
    setAmount() {
      let result = ''
      if (this.selfData.dan_jia && this.selfData.dan_jian_shu_liang) {
        result = this.$XEUtils.multiply(this.selfData.dan_jia, this.selfData.dan_jian_shu_liang)
      }
      this.selfData.dan_jian_jin_e = result
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$emit('success', this.selfData)
          this.popupCancel()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
